var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4447 19.6635H21.4688L24.5781 0.345703H29.554L26.4447 19.6635Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2803 0.345703L12.5345 13.6325L11.9719 10.7695L10.2996 2.06663C10.2996 2.06663 10.0951 0.345703 7.93696 0.345703H0.0920523L0 0.671284C1.8364 1.13726 3.59188 1.88311 5.20607 2.88317L9.53253 19.6635H14.7181L22.6346 0.345703H17.2803Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.427 19.6645H60.9989L57.0151 0.346633H53.0108C52.5261 0.309 52.0421 0.428507 51.6292 0.687796C51.2163 0.947085 50.8959 1.33265 50.7146 1.78849L43.2891 19.6645H48.4798L49.5026 16.7962H55.844L56.427 19.6645ZM50.9499 12.8324L53.5682 5.59728L55.036 12.8324H50.9499Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6788 4.99225L44.3896 0.857881C42.9529 0.332497 41.4422 0.0428739 39.9148 0C37.4448 0 31.579 1.09044 31.579 6.39793C31.579 11.3902 38.4625 11.4522 38.4625 14.0724C38.4625 16.6925 32.2898 16.2222 30.2493 14.5891L29.5078 18.9044C31.2875 19.6599 33.2032 20.033 35.1332 20C38.5289 20 43.6532 18.2222 43.6532 13.385C43.6532 8.36176 36.7083 7.89147 36.7083 5.71059C36.7083 3.52972 41.5513 3.80362 43.6788 4.99225Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9719 10.7746L10.2996 2.06663C10.2996 2.06663 10.0951 0.345703 7.93696 0.345703H0.0920523L0 0.671285C2.7017 1.36736 5.22253 2.64548 7.38976 4.41806C9.44697 6.08973 11.0282 8.28329 11.9719 10.7746Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.5883cdc6cb9a3167625724c3c7136bba.svg";
export { ForwardRef as ReactComponent };